/// <reference path="../../../typings/tsd.d.ts" /> 
/**
 * Created by jeremyconger on 4/26/17.
 */
//# sourceMappingURL=SelectGeometry.js.map